import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, viewChild } from '@angular/core';
import { WjFlexGrid, WjGridModule } from '@mescius/wijmo.angular2.grid';
import { WjInputModule } from '@mescius/wijmo.angular2.input';
import { ExcelUtils } from '../lib/Excel';

@Component({
    selector: 'app-tables-list',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        WjGridModule,
        WjInputModule
    ],
    templateUrl: './tables-list.component.html',
    styleUrl: './tables-list.component.scss',
})
export class TablesListComponent implements AfterViewInit {

    tables: Excel.Table[] = [];
    grid = viewChild.required<WjFlexGrid>('grid');

    async ngAfterViewInit(): Promise<void> {
        await this.listTables();
    }

    async listTables() {
        await ExcelUtils.run(async context => {
            context.workbook.tables.load('items/name,items/worksheet/name,items/rows/count,items/columns/count,items/range');
            await context.sync();

            this.tables = context.workbook.tables.items;
            const ranges = this.tables.map(it => it.getRange());
            ranges.forEach(range => range.load('address'));
            await context.sync();

            ranges.forEach((range, idx) => this.tables[idx]['_range'] = range);

            this.grid().itemsSource = this.tables;
        });
    }

    protected async onRowDoubleClick(event: MouseEvent) {
        const table = this.grid().selectedRows[0]?.dataItem as Excel.Table;
        await ExcelUtils.run(async ctx => {
            const tbl = ctx.workbook.tables.getItem(table.name);
            const range = tbl.getRange();
            range.load('worksheet/name');
            await ctx.sync();

            if (!range.isNullObject) {
                const worksheet = range.worksheet;
                worksheet.visibility = Excel.SheetVisibility.visible;
                worksheet.activate();
                range.select();
            }
        });
    }
}
